import {InputTextV2} from '@prtimes-basis/input';
import {FormField, useFormField} from '../../../form-field';
import styles from './company-name-field.module.css';
import companyRegistrationPageStyles from '@/features/company-registration/styles.module.css';

export function CompanyNameField() {
  return (
    <FormField.Root name='billingInfo.companyName'>
      <Body />
      <FormField.Error />
      <span className={styles.overseasNote}>
        FOR OVERSEAS CUSTOMERS：Please use English or alphabetical notation
      </span>
    </FormField.Root>
  );
}

function Body() {
  const {fieldProps} = useFormField();

  return (
    <InputTextV2
      required
      type='email'
      wrapperClassName={companyRegistrationPageStyles.sizedInput}
      {...fieldProps}
    />
  );
}
